import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/Login.vue"),
  },
  {
    path: "/",
    component: () => import("@/layout/index.vue"),
    redirect: "/overview",
    children: [
      {
        path: "overview",
        name: "overview",
        component: () => import("@/views/Overview/Overview.vue"),
      },
      {
        path: "home",
        name: "home",
        component: () => import("@/views/workspace/Home.vue"),
      },
    ],
  },
  {
    path: "/sign",
    name: "sign",
    component: () => import("@/views/workspace/Sign.vue"),
  },
  {
    path: "/calender",
    name: "calender",
    component: () => import("@/views/workspace/Calender.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL || "/"),
  routes,
});

router.beforeEach((to, from, next) => {
  if (localStorage.getItem("token")) {
    if (to.name === "login") {
      next("/");
    } else {
      next();
    }
  } else {
    if (to.name === "login") {
      next();
    } else {
      next({ name: "login" });
    }
  }
});

export default router;
